import axios from 'axios'
import packageJson from '../../package.json'
import { logoutHandler } from '../actions/sessionActions'

export const defaultHeaders = () => {
  axios.defaults.headers.common['Blinker-Client-Platform'] = 'MissionControl'
  axios.defaults.headers.common['Blinker-Client-Version'] = packageJson.version
}

export const interceptToken = (dispatch) => {
  axios.interceptors.request.use(
    (config) => {
      const token = JSON.parse(localStorage.getItem('accessToken') || 'null')

      if (token !== null) {
        config.headers['Authorization'] = `Bearer ${token.access_token}`
      }

      return config
    },
    (error) => {
      return Promise.reject(error)
    }
  )

  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      const status = error.response?.status
      const errorSource = error.response?.data?.from

      if (errorSource === 'doorkeeper' && status === 401) {
        localStorage.removeItem('accessToken')
        window.location.reload()
      }

      return Promise.reject(error)
    }
  )
}
